import { useRichTextEditor } from '@shared/rich-text-editor-core';
import React, { useRef } from 'react';

import { ImageOutlinedIcon } from '../../icons';

import ControlButton from './control-button';

function ImageControl() {
  const { editor, onImageUpload } = useRichTextEditor();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event?.target?.files?.[0];

    if (!editor) return;
    if (!(file instanceof File)) return;

    // Reset the input value to allow uploading the same file again
    event.target.value = '';

    if (typeof onImageUpload !== 'undefined') {
      const response = await onImageUpload(file);

      if (!response) return;

      const { url, fileName } = response;

      if (url !== undefined) {
        editor.chain().focus().setCustomImage({ src: url, content: fileName }).run();
      }
    } else {
      const url = URL.createObjectURL(file);

      editor.chain().focus().setImage({ src: url }).run();

      // Clean up the URL when the editor is destroyed
      editor.on('destroy', () => URL.revokeObjectURL(url));
    }
  };

  return (
    <>
      <ControlButton
        aria-label='Upload Image'
        data-rich-text-editor-control
        onClick={handleButtonClick}
      >
        <ImageOutlinedIcon />
      </ControlButton>
      {/* Hidden input used to open the file picker */}
      <input
        type='file'
        accept='.jpg,.jpeg,.png'
        ref={fileInputRef}
        onChange={handleImageUpload}
        style={{ display: 'none' }}
      />
    </>
  );
}

export default ImageControl;
export { ImageControl as RichTextEditorImageControl };
